import { render } from "./ArticleImageReel.vue?vue&type=template&id=0926a7e4&scoped=true"
import script from "./ArticleImageReel.vue?vue&type=script&lang=js"
export * from "./ArticleImageReel.vue?vue&type=script&lang=js"

import "./ArticleImageReel.vue?vue&type=style&index=0&id=0926a7e4&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0926a7e4"]])

export default __exports__